module.exports = __webpack_public_path__ + "static/media/fb.325c14ab.png";